import { render, staticRenderFns } from "./QuotePaymentTermItemsSection.vue?vue&type=template&id=716e1f1c&scoped=true&"
import script from "./QuotePaymentTermItemsSection.vue?vue&type=script&lang=ts&"
export * from "./QuotePaymentTermItemsSection.vue?vue&type=script&lang=ts&"
import style0 from "./QuotePaymentTermItemsSection.vue?vue&type=style&index=0&id=716e1f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e1f1c",
  null
  
)

export default component.exports